import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import Img from 'gatsby-image'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Theme from '../../../../vars/ThemeOptions'
 
const WrapRow = styled(Row)`
  .gatsby-image-wrapper {    
    margin-bottom: 2rem;
  }
  &.green {
    .gatsby-image-wrapper {
      border-bottom: 12px solid ${Theme.hex('primary')};
    }
    h3 {
      color: ${Theme.hex('primary')};
    }
  }
  &.yellow {
    .gatsby-image-wrapper {
      border-bottom: 12px solid ${Theme.hex('yellow')};
    }
    h3 {
      color: ${Theme.hex('yellow')};
    }
  }
  &.red {
    .gatsby-image-wrapper {
      border-bottom: 12px solid ${Theme.hex('red')};
    }
    h3 {
      color: ${Theme.hex('red')};
    }
  }
`
 
const Condition = ({ condition, color }) => {
  // console.log("condition: ", condition)
  const { fluid } = condition.image ? condition.image : null
  const alt = condition.image && condition.image.title ? condition.image.title : null
  return (
    <WrapRow className={color}>
      <Col xs={12} lg={4} >
        <Img fluid={fluid} alt={alt} />
      </Col>
      <Col xs={12} lg={5} >
        <h3>{condition.title}</h3>
        {documentToReactComponents(condition.copy.json)}
      </Col>
    </WrapRow>
  )
}
 
export default Condition